
import React from 'react';
import { TasksSectionWrapper } from './Tasks/TasksSectionWrapper';

export const TasksSection = () => {
  return <TasksSectionWrapper />;
};
